/**
 * Module for building Markdown atoms.
 * These functions build the smallest markdown building blocks possible.
 */

import type { TemplateAtoms } from '../types';


const markdownAtoms: TemplateAtoms<string> = {
  heading1(content: string) {
    return `# ${content}`;
  },
  heading2(content: string) {
    return `## ${content}`;
  },
  heading3(content: string) {
    return `### ${content}`;
  },
  bulletPoint(content: string) {
    return `- ${content}`;
  },
  text(content: string) {
    return content;
  },
  bold(content: string) {
    return `**${content}**`;
  },
  error(content: string) {
    return content;
  },
  emptyLine() {
    return '';
  },
  emptyLineSmall() {
    return '';
  },
};

export default markdownAtoms;
